var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"item",class:_vm.classObject,staticStyle:{"border-radius":"0"},attrs:{"title":_vm.title},on:{"click":_vm.onItemClick}},[_c('font-awesome-icon',{attrs:{"icon":['fas',_vm.icon],"size":"lg"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }